export default __webpack_public_path__ + "static/media/minisite-pagetype-landing.02205476.svg";